
import scrollIntoView, { SmoothBehaviorOptions } from 'smooth-scroll-into-view-if-needed';
import dateformat from 'dateformat';
import megatron from '@stencil/megatron';
import { fetchHelper } from './../../utils/fetchHelper';
import { VOYAGER_SEARCH_URL } from '../config/apiPoints';
import { voyagerSearch } from '../config/config';
import getDateObj from './utils/GetDateObj';

export function scrollEletoView(idOfElToScrollTo, options?: Partial<SmoothBehaviorOptions>) {
  const elToScrollTo = document && document.querySelector(idOfElToScrollTo);
  if (!elToScrollTo) {
    return;
  }
  scrollIntoView(elToScrollTo, options);
}

export const prepareSRPURL = (params) => {
  const { src_name, dest_name, src_id, dest_id, selectedDate, filterQry, sortBy, dest_autosuggest, src_autosuggest, calendar_select } = params;
  let url = `/bus/search?src=${src_name}&dest=${dest_name}&src_id=${src_id}&dest_id=${dest_id}&onwDate=${selectedDate}&page_source=seo&dest_autosuggest=${dest_autosuggest}&src_autosuggest=${src_autosuggest}&calendar_select=${calendar_select}`;
  if (params.opid) {
    //rtc
    url += `&operators=${params.opid}`
  }
  if (sortBy) {
    url += `&sortBy=${sortBy}`
  }
  if (params.isFilter) {
    url += filterQry
  }
  return (__ENV_CONFIG__.__GOIBIBO__ + url);
}

export function getBusSeatLayoutURL({
  source,
  destination,
  onwDate,
  retDate,
  depTime,
  arrTime,
  duration,
  operatorName,
  busType,
  bid,
  operatorType,
  tripType,
  routeid,
  src_vid,
  dest_vid,
  src_id,
  dest_id,
  op
}) {
  // const qryObjString = JSON.stringify({
  //   source,
  //   destination,
  //   onwDate,
  //   retDate,
  //   depTime,
  //   arrTime,
  //   duration,
  //   operatorName,
  //   busType,
  //   bid,
  //   operatorType,
  //   tripType,
  //   routeid,
  //   src_vid,
  //   dest_vid,
  //   src_id,
  //   dest_id,
  //   op
  // });
  const url = `${__ENV_CONFIG__.__GOIBIBO__}/bus/seatlayout/?tracking=direct&bid=${bid}&routeid=${routeid}&op=${op}&src=${source}&dest=${destination}&src_id=${src_id}&dest_id=${dest_id}&src_vid=${src_vid}&dest_vid=${dest_vid}&doj=${onwDate}&all_data_required=${true}&flavour=mobile&dt=${depTime}&at=${arrTime}&du=${duration}&cr=${operatorName}&bt=${busType}`;
  return url;
  // return `${__ENV_CONFIG__.__GOIBIBO__}/bus/seatlayout?tracking=seo&page_source=seo&query=${encodeURIComponent(qryObjString)}`;
}

export function prearebid(params: {
  src_name: string; dest_name: string; src_vid: string | number; dest_vid: string | number; selectedDate: any
}) {
  const { src_name, dest_name, src_vid, dest_vid, selectedDate } = params;
  const date = dateformat(selectedDate, 'yyyymmdd');

  let bid = `bus-${src_name}-${dest_name}-${date}-0-0-0-0-${src_vid}-${dest_vid}`;
  return bid;
}
export function queryStringUrlReplacement(url, param, value) {
  var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;

  if (match === null) {
    // append new param
    var hasQuestionMark = /\?/.test(url);
    delimiter = hasQuestionMark ? "&" : "?";
    newString = url + delimiter + param + "=" + value;
  } else {
    delimiter = match[0].charAt(0);
    newString = url.replace(re, delimiter + param + "=" + value);
  }

  return newString;
}
export function replaceSRPUrlState({ history, search, keyName, inputValues }) {
  const { src_name, dest_name, src_vid, dest_vid, selectedDate } = inputValues;

  try {
    const bid = prearebid({
      src_name,
      dest_name,
      src_vid,
      dest_vid,
      selectedDate

    })
    const url = queryStringUrlReplacement(search, keyName, bid)

    history.replace(url);
  } catch (err) {
    console.warn(err);
  }
}


export var getQueryString = function (field, url) {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
};

export var RemoveParamInURL = function (field, url) {
  var href = url ? url : window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  var removedParamURL = ''
  if(string){
    removedParamURL = href.replace(string[0],'')
    return {isPresent: true, removedParamURL}
  }
  return {isPresent: false, removedParamURL}
};

export var removeTermsOfServiceFromURLAndRedirect = function(url){
  var href = url ? url : window.location.href;
  if(href.includes('buses/info/terms-of-services/') || href.includes('tickets/info/terms-of-services/')){
    console.log('getting here')
   href =  href.replace('info/terms-of-services/','')
   window.location.href = href
  }
}

export function scrollToHead(id: string) {
  if (!id) {
    return;
  }
  const idOfElToScrollTo = `#${id}`;
  scrollEletoView(idOfElToScrollTo, {
    behavior: 'smooth',
    block: 'start',
  });
}

export const initAdConfig = (useViewCB, errorCB) => {
  try {
    let adInitialConfig = {
      userCallbackForView: function (id) {
        console.log("view callback: ", id);
        useViewCB && useViewCB(id);
      },
      userClickHandlerForClick: function () {
        console.log("click callback");
      },
      onError: function (er) {
        console.log("On Error Callback:", er);
        errorCB && errorCB(er);
      },
      ORG: "GI",
      AUTH_COOKIE_KEY: "OAUTH-GOIBIBO",
    };
    if (window) {
      if (window.AdMMTSDK) {
        window.AdMMTSDK.init(adInitialConfig);
      } else {
        window.AdMMTSDK = [];
        window.AdMMTSDK.push(adInitialConfig);
      }
    }
  } catch (err) {
    console.warn(err);
  }
}

export function pushDataToNewrelic(queryStr) {
  const url = `https://dexter.goibibo.com/common/newrelic/?serviceApp=superbusmseo&${queryStr}`;

  megatron({
    name: 'newrelic custom param push',
    type: 'GET',
    url,
  })
}

export function pushDataToNewrelicFromServer(queryStr) {
  const url = `https://dexter.goibibo.com/common/newrelic/?serviceApp=superbusmseo&${queryStr}`;
  fetchHelper({
    name: 'newrelic custom param push',
    type: 'GET',
    url: url,
  });
}

/**This function check whether the val is present in arr or not if present then remove from arr and if not then push into arr */
export function addRemoveArrayOperation(arr: any[], val: any) {
  const index = arr.indexOf(val);
  if (index === -1) {
    arr.push(val);
  } else {
    arr.splice(index, 1);
  }
  return arr;
}

export function removeElementFromArray({ data, item }) {
  return data.filter(dataItem => {
    if (dataItem !== item) return dataItem;
  });
}

export const getFormattedDateForSRP = (val) => {
  let dateStr = '';
  const monthShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const day = days[val.getDay()];
  const dd = val.getDate();
  const month = monthShort[val.getMonth()];
  const year = val.getFullYear();
  dateStr = `${day} ${dd},${month} ${year}`;
  return dateStr;
}

export function searchWidgetLocationSearchURL(params) {
  const query = JSON.stringify({ "search_query": params, limit: voyagerSearch.itemCountToFetch })
  const url = `${__ENV_CONFIG__.__VOYAGER__}${VOYAGER_SEARCH_URL}${query}`;
  return url;
};

export function capitalize(s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function getRoutePageUrl(src, dest) {
  if (src && dest) {
    return `${__ENV_CONFIG__.__GOIBIBO__}/bus/${src}-to-${dest}-bus-tickets/`
  }
  return ''
}

export const getCachingKey = (src="", dest="", filterStr = "", str = "", cacheKey = "route_category") => {
  const date = getDateObj();
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2);
  const key = `bus_web_${cacheKey}${src ? `_${src}` : ''}${dest ? `_${dest}` : ''}${filterStr ? `_${filterStr}` : ''}_${year}-${month}-${day}${str ? `_${str}` : ''}`
  return key;
}

export function isFilterEmpty(filters) {
  let isEmpty = true;
  Object.keys(filters).forEach(tripType => {
    Object.keys(filters[tripType]).forEach(filterType => {
      if (filterType === 'primary' && filters[tripType][filterType].length) {
        isEmpty = false;
      }

      if (filterType === 'secondary') {
        Object.keys(filters[tripType][filterType]).forEach(filterItem => {
          if (filters[tripType][filterType][filterItem].length) {
            isEmpty = false;
          }
        });
      }
    });
  });
  return isEmpty;
}

export function isClientSide() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

export function getDefaultFilters(type = 'onw', primary = [], operatorsList = []) {
  let primaryFilters = []
  if (primary && primary.length) {
    primaryFilters = primary
  }
  return {
    [type]:
    {
      primary: primaryFilters,
      secondary: {
        timeslots: [],
        bpList: [],
        dpList: [],
        operatorsList: operatorsList && operatorsList.length ? operatorsList : [],
      }
    }
  };
}

export function getLabelVal({ bpList, dpList, operatorsList, timeslots, primary }) {
  let labelVal = ''
  if (bpList && bpList.length) {
    labelVal += `&boardingPoints=${bpList.join("|")}`
  }
  if (dpList && dpList.length) {

    labelVal += `&droppingPoints=${dpList.join("|")}`
  }
  if (operatorsList && operatorsList.length) {

    labelVal += `&operators=${operatorsList.join("|")}`
  }

  if (timeslots && timeslots.length) {

    labelVal += `&timeslots=${timeslots.join("|")}`
  }
  if (primary && primary.length) {
    labelVal += `&filters=${primary.join("|")}`
  }
  return labelVal
}

export const getInitSelectedFilters = ({ filterStr, operators }: { filterStr?: string; operators?: any }) => {
  let busType = [];
  let preselectedOperators = {}
  if (filterStr && filterStr.length) {
    let str = filterStr.toLowerCase();
    if (str.indexOf('non-ac') !== -1) {
      busType.push('nonac');
      str = str.replace('non-ac', '')
    }
    if (str.indexOf('semi-sleeper') !== -1) {
      busType.push('sleeper');
      str = str.replace('semi-sleeper', '')
    }
    if (str.indexOf('mercedes-benz') !== -1) {
      busType.push('mercedes-benz');
      str = str.replace('mercedes-benz', '')
    }
    const types = str.split("-");
    busType = busType.concat(types);
  }
  if (operators && Object.keys(operators).length) {
    preselectedOperators = Object.assign({}, operators);
  }

  return {
    popular: [],
    busType: busType,
    departureTime: [],
    arrivalTime: [],
    boardingPoint: [],
    droppingPoint: [],
    operator: preselectedOperators,
    amenities: [],
  };
}

export function prepareRespSRPURL(params) {
  /*  https://newprodpp.goibibo.com/bus/search?
* bid=bus-Delhi-Jaipur-20210801-0-0-0-0-2820046943342890302-4278754392716898526&
* src=Delhi&dest=Jaipur&src_id=2820046943342890302&dest_id=4278754392716898526&onwDate=20210801
* &page_source=seo&routeId=redbusnew@1000008438594378655&rtcId=15499&section=amenities_photos&viewMoreBuses=true&isFilter=true&popular=go_safe|soc_dis&busType=ac|nonac|seater|sleeper&sortBy=arrival&amenities=Movie|Bedsheet&arrivalTime=00-06|06-12|12-18|18-24&departureTime=00-06|06-12|12-18|18-24&boardingPoint=Filmistan|Filmistan2&droppingPoint=Jaipur|abcd&operatorInfo=20218--zingbus|123--srs&operators=20218|123%20&offsetDate=2&others={}
*/
  const { src, dest, src_id, dest_id, date, filterQry, sortBy, rtcId, routeId, viewMoreBuses, selectedFilters, isFilter, dest_autosuggest, src_autosuggest, calendar_select, operatorName = '', operatorId = '' } = params;

  let url = `/bus/search?src=${src}&dest=${dest}&src_id=${src_id}&dest_id=${dest_id}&onwDate=${date}&page_source=seo`;
  if (dest_autosuggest) {
    url += `&dest_autosuggest=${dest_autosuggest}`
  }
  if (src_autosuggest) {
    url += `&src_autosuggest=${src_autosuggest}`
  }
  if (calendar_select) {
    url += `&calendar_select=${calendar_select}`
  }
  if (rtcId) {
    url += `&rtcId=${rtcId}`
  }
  if (routeId) {
    url += `&routeId=${routeId}`
  }
  if (viewMoreBuses) {
    url += `&viewMoreBuses=${viewMoreBuses}`
  }

  if (isFilter) {
    url += `&isFilter=true`;
    const { amenities, arrivalTime, boardingPoint, busType, departureTime, droppingPoint, popular, operator, primary } = selectedFilters;
    if (amenities && amenities.length) {
      url += `&amenities=${amenities.join("|")}`
    }
    if (primary && primary.length) {
      url += `&filters=${primary.join("|")}&busType=${primary.join("|")}`

    }
    if (arrivalTime && arrivalTime.length) {
      url += `&arrivalTime=${arrivalTime.join("|")}`
    } if (boardingPoint && boardingPoint.length) {
      url += `&boardingPoint=${boardingPoint.join("|")}`
    } if (busType && busType.length) {
      url += `&busType=${busType.join("|")}`
    } if (departureTime && departureTime.length) {
      url += `&departureTime=${departureTime.join("|")}`
    } if (droppingPoint && droppingPoint.length) {
      url += `&droppingPoint=${droppingPoint.join("|")}`
    } if (popular && popular.length) {
      url += `&popular=${popular.join("|")}`
    } if (operator && Object.keys(operator).length) {
      //`&operatorId=${Object.keys(operator)[0]}&operatorName=${operator[Object.keys(operator)[0]]}`
      let operatorSlug = '&operatorInfo='
      let mobileOperatorSlug = '&operators='
      for (let opid in operator) {
        operatorSlug += `${opid}--${operator[opid]}|`

        mobileOperatorSlug += `${opid}|`
        mobileOperatorSlug = mobileOperatorSlug.slice(0, -1);
      }

      url += operatorSlug;
      url += mobileOperatorSlug;

    }
    if(operatorName && operatorId){
      url += `&operatorInfo=${operatorId}--${operatorName}|&operators=${operatorId}`
    }
  }
  // if(params.opid){
  //  //rtc
  //   url += `&operators=${params.opid}`

  // }

  if (sortBy) {
    url += `&sortBy=${sortBy}&isFilter=true`
  }
  // if(params.isFilter){
  //   url += filterQry

  //   }          
  return (url);
}

export function prepareSeatLayoutURL({ data, src, dest, onwDate, src_id, dest_id }) {
  let operatorType = '';
  if (data.chooseBpDpFirst && data.cat_card) {
    operatorType = 'apsrtc';
  } else if (data.chooseBpDpFirst && !data.cat_card) {
    operatorType = 'rtc';
  } else {
    operatorType = 'private';
  }
  return `/bus/seatlayout/?bid=${data.fl[0].bid}&routeid=${data.fh}&op=${data.fl[0].op}&src=${src}&dest=${dest}&src_id=${data.src_id}&dest_id=${data.dest_id}&src_vid=${src_id}&dest_vid=${dest_id}&doj=${onwDate}&all_data_required=${true}&flavour=mobile&dt=${data.fl[0].dt}&at=${data.fl[0].at}&du=${data.fl[0].du}&cr=${data.fl[0].cr}&bt=${data.fl[0].bt}`;
}

export const isMobileView = () => {
  let width = 300;
  if (typeof document !== "undefined" && document && document.body && document.body.clientWidth) {
    width = document.body.clientWidth;
  }
  if (width > 768) {
    return false;
  }
  return true;
}


export const getRouteClientDumpData = (src, dest, slug) => {
  return {
    "status": true,
    "message": "Data not found in LOB",
    "data": {
      "redirect_to": "",
      "dummy_data": true,
      "page_type": "bus_sector",
      "canonical_url": `https://www.goibibo.com/bus/${slug}/`,
      "seo_meta": {
        "meta_title": `${src} to ${dest} Bus, Upto Rs.100 OFF on  Bus Tickets Booking | Goibibo`,
        "meta_description": `Book Sanitized  ${src} to ${dest} Bus ticket online from Goibibo. Get the best deals on ${src} to ${dest} bus route. Use Coupon FIRSTBUS and get Rs 100 off.`,
        "meta_keywords": `${src} to ${dest} bus, ${src} to ${dest} sanitised bus, ${src} to ${dest} Covid-19 Safe bus, ${src} to ${dest} bus tickets, ${src} to ${dest} sanitised bus tickets, Book ${src} to ${dest} bus tickets, ${src} to ${dest} Bus Tickets Online, Cheapest bus tickets for ${src} to ${dest}`,
        "h1_title": `${src} To ${dest} Bus`,
        "sub_title": `${src} To ${dest} Bus`,
        "breadcrumb": [
          {
            "title": "Goibibo",
            "url": "https://www.goibibo.com/"
          },
          {
            "title": "Bus Booking",
            "url": "https://www.goibibo.com/bus/"
          },
          {
            "title": `${src}`,
            "url": `https://www.goibibo.com/bus/${src}-buses/`
          },
          {
            "title": `${src} to ${dest} Bus`
          }
        ]
      },
      "general_content": `Book ${src} to ${dest} bus tickets at the cheapest price. Use promo code: \\\"FIRSTBUS\\\" and get up to ₹100 OFF on your ${src} to ${dest} bus booking. Choose from the many options listed below for your ${src} to ${dest} bus tickets, and enjoy fastest booking, big offers & savings on bus tickets visit Goibibo. Also check the bus schedule, status for your return <a href='https://www.goibibo.com/bus/${dest}-to-${src}-bus-tickets/'>${dest} to ${src} bus</a> tickets online.`,
      "template": {
        "content": "",
        "faq": {
          "faq_heading": `FAQs About Buses from ${src} to ${dest}`,
          "faq_content": [
            {
              "q": `\nWhat all types of buses available in ${src} to ${dest} Bus service?\n`,
              "a": "\nWe are serving A/C Seater (2+2), NON A/C Seater / Sleeper (2+1), A/C Sleeper (2+1), A/C Seater / Sleeper (2+1), NON A/C Sleeper (2+1) etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n"
            },
            {
              "q": `\nWhat are the boarding points in ${src} for ${src} to ${dest} Bus service?\n`,
              "a": `\nBoarding points for this bus route in ${src} are ${src} Bus Stand, ${src} Private Bus Stand etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            },
            {
              "q": `\nWhat are the dropping points in ${dest} for the ${src} ${dest} Bus service?\n`,
              "a": `\nDropping points for this bus route in ${dest} are ${dest} Bus Stand, ${dest} Private Bus Stand etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            }
          ]
        }
      },
      "actual_src_slug": `${src}`,
      "actual_dest_slug": `${dest}`,
      "src_id": "8312659373678178248",
      "src": `${src}`,
      "dest_id": "4173145109378020981",
      "dest": `${dest}`,
      "date": dateformat(new Date(), 'yyyymmdd'),
      "bus_op": [],
      "total_buses": 0,
      "filter_data": {
        "gps_enabled_buses": 0,
        "reddeal_buses": 0,
        "on_time_buses": 0,
        "zct_buses": 0,
        "sold_out_buses": 0,
        "ac_buses": 0,
        "non-ac_buses": 0,
        "seater_buses": 0,
        "sleeper_buses": 0,
        "go_safe_buses": 0,
        "static_filters": [],
        "rtc_ops": [],
        "no_of_buses": 0,
        "special_filter": [],
        "amenities": [
          "USB port for charger",
          "Disposable Seat Covers",
          "Captain seat",
          "Personal TV",
          "WIFI",
          "Blankets",
          "Wet Napkin",
          "Tour Guide",
          "Staff with masks",
          "Charging Point",
          "Snacks",
          "Hand Sanitisers Provided",
          "Deep Cleaned Buses",
          "Water Bottle",
          "Emergency Contact Number",
          "CCTV",
          "Regular temperature checks",
          "Thermal Scanner",
          "No blankets",
          "Toilet",
          "M-ticket",
          "Magazine Pouch",
          "Reading Light",
          "Movie"
        ]
      },
      "bus_data": {
        "buses": [],
        "total_buses": 0,
        "bp_dict": {},
        "dp_dict": {},
        "ps": "",
        "popular_filters": [
          {
            "k": "go_safe",
            "v": "GoSafe Buses"
          },
          {
            "k": "soc_dis",
            "v": "Social Distancing Buses"
          },
          {
            "k": "reddeal",
            "v": "GoDeal Discount"
          },
          {
            "k": "gps",
            "v": "Live Tracking"
          },
          {
            "k": "zct_msg",
            "v": "Free Cancellation"
          },
          {
            "k": "rating",
            "v": "Top Rated Buses"
          }
        ]
      },
      "offers": getBusOffers(),
      "footer_links": getFooterLinks(),
      "cross_template_links": {}
    }
  }
}

export const getOperatorClientDumpData = (opname, opid, slug) => {
  return {
    "status": true,
    "data": {
      "redirect_to": "",
      "dummy_data": true,
      "operatorId": "",
      "operatorName": opname,
      "page_type": "bus_operator",
      "canonical_url": `https://www.goibibo.com/bus/${slug}/`,
      "op_title": opname,
      "seo_meta": {
        "meta_title": `${opname} Sanitised Bus Booking @ ₹250 upto 10% off,${opname} Bus Timings`,
        "meta_description": `${opname} sanitised bus ticket booking @ ₹250 from Goibibo. Find ${opname} bus timings, amenities info for 1+ sanitised buses.`,
        "meta_keywords": `${opname} ,${opname} Booking, Covid-19 Safe ${opname} Booking,${opname} sanitised bus booking`,
        "h1_title": `${opname} Sanitised Bus Booking @ ₹250 upto 10% off,${opname} Bus Timings`,
        "sub_title": `${opname} Sanitised Bus Booking @ ₹250 upto 10% off,${opname} Bus Timings`,
        "breadcrumb": [
          {
            "title": "Goibibo",
            "url": "https://www.goibibo.com/"
          },
          {
            "title": "Bus Booking",
            "url": "https://www.goibibo.com/bus/"
          },
          {
            "title": `${opname} Bus`
          }
        ]
      },
      "template": {
        "content": "",
        "faq": {
          "faq_heading": `FAQs About ${opname} Bus`,
          "faq_content": [
            {
              "q": `\nWhat are the top bus amenities provided by ${opname}?\n`,
              "a": `\nTop bus amenities provided by ${opname} are Emergency Contact Number, Reading Light, Blankets, Charging Point, Wet Napkin, Water Bottle, Movie, CCTV, M-ticket, etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            },
            {
              "q": `\nWhich type of buses currently operated by ${opname}?\n`,
              "a": `\nCurrently ${opname} is serving A/C Seater (2+2), NON A/C Seater / Sleeper (2+1), NON A/C Sleeper (2+1), A/C Seater / Sleeper (2+1), A/C Sleeper (2+1),  etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            }
          ]
        }
      },
      "offers": getBusOffers(),
      "footer_links": getFooterLinks(),
      "bus_reviews": [],
      "bus_amenities": [
        "USB port for charger",
        "Disposable Seat Covers",
        "Captain seat",
        "Personal TV",
        "WIFI",
        "Blankets",
        "Wet Napkin",
        "Tour Guide",
        "Staff with masks",
        "Charging Point",
        "Snacks",
        "Hand Sanitisers Provided",
        "Deep Cleaned Buses",
        "Water Bottle",
        "Emergency Contact Number",
        "CCTV",
        "Regular temperature checks",
        "Thermal Scanner",
        "No blankets",
        "Toilet",
        "M-ticket",
        "Magazine Pouch",
        "Reading Light",
        "Movie"
      ],
      "route_buses": [],
      "top_bus_route_op": [
        {
          "name": "Mumbai to Pune Bus",
          "meta_alt": "Mumbai to Pune Bus",
          "meta_title": "Mumbai to Pune Bus",
          "link": "https://www.goibibo.com/bus/mumbai-to-pune-bus-tickets/",
          "from_city": "Mumbai",
          "to_city": "Pune"
        },
        {
          "name": "Bangaluru to Hyderabad Bus",
          "meta_alt": "Bangaluru to Hyderabad Bus",
          "meta_title": "Bangaluru to Hyderabad Bus",
          "link": "https://www.goibibo.com/bus/bangaluru-to-hyderabad-bus-tickets/",
          "from_city": "Bangaluru",
          "to_city": "Hyderabad"
        },
        {
          "name": "Delhi to Manali Bus",
          "meta_alt": "Delhi to Manali Bus",
          "meta_title": "Delhi to Manali Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-manali-bus-tickets/",
          "from_city": "Delhi",
          "to_city": "Manali"
        },
        {
          "name": "Bangaluru to Chennai Bus",
          "meta_alt": "Bangaluru to Chennai Bus",
          "meta_title": "Bangaluru to Chennai Bus",
          "link": "https://www.goibibo.com/bus/bangaluru-to-chennai-bus-tickets/",
          "from_city": "Bangaluru",
          "to_city": "Chennai"
        },
        {
          "name": "Delhi to Jaipur Bus",
          "meta_alt": "Delhi to Jaipur Bus",
          "meta_title": "Delhi to Jaipur Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-jaipur-bus-tickets/",
          "from_city": "Delhi",
          "to_city": "Jaipur"
        },
        {
          "name": "Jaipur to Delhi Bus",
          "meta_alt": "Jaipur to Delhi Bus",
          "meta_title": "Jaipur to Delhi Bus",
          "link": "https://www.goibibo.com/bus/jaipur-to-delhi-bus-tickets/",
          "from_city": "Jaipur",
          "to_city": "Delhi"
        },
        {
          "name": "Ooty to Bangaluru Bus",
          "meta_alt": "Ooty to Bangaluru Bus",
          "meta_title": "Ooty to Bangaluru Bus",
          "link": "https://www.goibibo.com/bus/ooty-to-bangaluru-bus-tickets/",
          "from_city": "Ooty",
          "to_city": "Bangaluru"
        },
        {
          "name": "Manali to Delhi Bus",
          "meta_alt": "Manali to Delhi Bus",
          "meta_title": "Manali to Delhi Bus",
          "link": "https://www.goibibo.com/bus/manali-to-delhi-bus-tickets/",
          "from_city": "Manali",
          "to_city": "Delhi"
        },
        {
          "name": "Ooty to Chennai Bus",
          "meta_alt": "Ooty to Chennai Bus",
          "meta_title": "Ooty to Chennai Bus",
          "link": "https://www.goibibo.com/bus/ooty-to-chennai-bus-tickets/",
          "from_city": "Ooty",
          "to_city": "Chennai"
        },
        {
          "name": "Chennai to Ooty Bus",
          "meta_alt": "Chennai to Ooty Bus",
          "meta_title": "Chennai to Ooty Bus",
          "link": "https://www.goibibo.com/bus/chennai-to-ooty-bus-tickets/",
          "from_city": "Chennai",
          "to_city": "Ooty"
        }
      ],
      "cross_template_links": {
        "top_cities_for_op": {
          "title": "Popular cities",
          "links": [
            {
              "text": "Ooty Bus",
              "url": "https://www.goibibo.com/bus/ooty-buses/"
            },
            {
              "text": "Mumbai Bus",
              "url": "https://www.goibibo.com/bus/mumbai-buses/"
            },
            {
              "text": "Surat Bus",
              "url": "https://www.goibibo.com/bus/surat-buses/"
            },
            {
              "text": "Chennai Bus",
              "url": "https://www.goibibo.com/bus/chennai-buses/"
            },
            {
              "text": "Udaipur Bus",
              "url": "https://www.goibibo.com/bus/udaipur-buses/"
            },
            {
              "text": "Kolkata Bus",
              "url": "https://www.goibibo.com/bus/kolkata-buses/"
            },
            {
              "text": "Shimla Bus",
              "url": "https://www.goibibo.com/bus/shimla-buses/"
            },
            {
              "text": "Ranchi Bus",
              "url": "https://www.goibibo.com/bus/ranchi-buses/"
            },
            {
              "text": "Hyderabad Bus",
              "url": "https://www.goibibo.com/bus/hyderabad-buses/"
            },
            {
              "text": "Jaipur Bus",
              "url": "https://www.goibibo.com/bus/jaipur-buses/"
            }
          ]
        }
      }
    },
    "message": ""
  }
}

export const getCityClientDumpData = (cityName, slug) => {
  return {
    "status": true,
    "data": {
      "redirect_to": "",
      "dummy_data": true,
      "from_buses": [],
      "to_buses": [],
      "city_name": cityName,
      "city_vid": "1465586071465568885",
      "min_fare": 96,
      "bps": [
        `${cityName} Bus Stand`
      ],
      "dps": [
        `${cityName} Bus Stand`
      ],
      "page_type": "bus_city",
      "canonical_url": `https://www.goibibo.com/bus/${slug}/`,
      "reverse_tab": false,
      "seo_meta": {
        "meta_title": `${cityName} Sanitised Bus Tickets: Bus to ${cityName}, from ${cityName}, ${cityName} Bus Timetable`,
        "meta_description": `Find top ${cityName} Bus operators at lowest price. Get best offers on ${cityName} Bus ticket booking.`,
        "meta_keywords": `${cityName} bus, ${cityName} sanitised bus, ${cityName} Covid-19 Safe bus, buses in ${cityName}, ${cityName} bus timings, ${cityName} bus schedule, Bus from ${cityName}, ${cityName} Bus Time Table`,
        "h1_title": `${cityName} Sanitised Bus Tickets: Bus to ${cityName}, from ${cityName}, ${cityName} Bus Timetable`,
        "sub_title": `${cityName} Sanitised Bus Tickets: Bus to ${cityName}, from ${cityName}, ${cityName} Bus Timetable`,
        "breadcrumb": [
          {
            "title": "Goibibo",
            "url": "https://www.goibibo.com/"
          },
          {
            "title": "Bus Booking",
            "url": "https://www.goibibo.com/bus/"
          },
          {
            "title": `${cityName} Bus`
          }
        ]
      },
      "template": {
        "content": "",
        "faq": {
          "faq_heading": `FAQs About ${cityName}  Bus`,
          "faq_content": [
            {
              "q": `\nWhat all types of buses available in ${cityName}?\n`,
              "a": "\nWe are serving A/C Seater (2+2), NON A/C Seater / Sleeper (2+1), A/C Sleeper (2+1), A/C Seater / Sleeper (2+1), NON A/C Sleeper (2+1) etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n"
            },
            {
              "q": `\nWhat are the popular boarding points in ${cityName}?\n`,
              "a": `\nPopular boarding points in ${cityName} are ${cityName} Bus Stand, ${cityName} Private Bus Stand etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            },
            {
              "q": `\nWhat are the popular dropping points in ${cityName}?\n`,
              "a": `\nPopular dropping points in ${cityName} are ${cityName} Bus Stand, ${cityName} Private Bus Stand etc. <a href='https://www.goibibo.com/bus'>Book Now</a>\n`
            }
          ]
        }
      },
      "cross_template_links": {
        "cities_near_src": {
          "title": "Popular cities",
          "links": [
            {
              "text": "Manali Bus",
              "url": "https://www.goibibo.com/bus/manali-buses/"
            },
            {
              "text": "Ranchi Bus",
              "url": "https://www.goibibo.com/bus/ranchi-buses/"
            },
            {
              "text": "Shimla Bus",
              "url": "https://www.goibibo.com/bus/shimla-buses/"
            },
            {
              "text": "Udaipur Bus",
              "url": "https://www.goibibo.com/bus/udaipur-buses/"
            },
            {
              "text": "Chennai Bus",
              "url": "https://www.goibibo.com/bus/chennai-buses/"
            },
            {
              "text": "Delhi Bus",
              "url": "https://www.goibibo.com/bus/delhi-buses/"
            },
            {
              "text": "Jaipur Bus",
              "url": "https://www.goibibo.com/bus/jaipur-buses/"
            },
            {
              "text": "Kolkata Bus",
              "url": "https://www.goibibo.com/bus/kolkata-buses/"
            },
            {
              "text": "Patna Bus",
              "url": "https://www.goibibo.com/bus/patna-buses/"
            },
            {
              "text": "Pune Bus",
              "url": "https://www.goibibo.com/bus/pune-buses/"
            }
          ]
        }
      },
      "offers": getBusOffers(),
      "footer_links": getFooterLinks(),
      "message": ""
    }
  }
}
function getFooterLinks() {
  return [
    {
      "title": "Popular Bus Routes",
      "links_data": [
        {
          "name": "Delhi to Manali Bus",
          "meta_alt": "Delhi to Manali Bus",
          "meta_title": "Delhi to Manali Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-manali-bus-tickets/"
        },
        {
          "name": "Jaipur to Delhi Bus",
          "meta_alt": "Jaipur to Delhi Bus",
          "meta_title": "Jaipur to Delhi Bus",
          "link": "https://www.goibibo.com/bus/jaipur-to-delhi-bus-tickets/"
        },
        {
          "name": "Chandigarh to Delhi Bus",
          "meta_alt": "Chandigarh to Delhi Bus",
          "meta_title": "Chandigarh to Delhi Bus",
          "link": "https://www.goibibo.com/bus/chandigarh-to-delhi-bus-tickets/"
        },
        {
          "name": "Bengaluru to Goa Bus",
          "meta_alt": "Bengaluru to Goa Bus",
          "meta_title": "Bengaluru to Goa Bus",
          "link": "https://www.goibibo.com/bus/bengaluru-to-goa-bus-tickets/"
        },
        {
          "name": "Mumbai to Goa Bus",
          "meta_alt": "Mumbai to Goa Bus",
          "meta_title": "Mumbai to Goa Bus",
          "link": "https://www.goibibo.com/bus/mumbai-to-goa-bus-tickets/"
        },
        {
          "name": "Delhi to Dehradun Bus",
          "meta_alt": "Delhi to Dehradun Bus",
          "meta_title": "Delhi to Dehradun Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-dehradun-bus-tickets/"
        },
        {
          "name": "Delhi to Chandigarh Bus",
          "meta_alt": "Delhi to Chandigarh Bus",
          "meta_title": "Delhi to Chandigarh Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-chandigarh-bus-tickets/"
        },
        {
          "name": "Bengaluru to Chennai Bus",
          "meta_alt": "Bengaluru to Chennai Bus",
          "meta_title": "Bengaluru to Chennai Bus",
          "link": "https://www.goibibo.com/bus/bengaluru-to-chennai-bus-tickets/"
        },
        {
          "name": "Hyderabad to Bengaluru Bus",
          "meta_alt": "Hyderabad to Bengaluru Bus",
          "meta_title": "Hyderabad to Bengaluru Bus",
          "link": "https://www.goibibo.com/bus/hyderabad-to-bengaluru-bus-tickets/"
        },
        {
          "name": "Bengaluru to Hyderabad Bus",
          "meta_alt": "Bengaluru to Hyderabad Bus",
          "meta_title": "Bengaluru to Hyderabad Bus",
          "link": "https://www.goibibo.com/bus/bengaluru-to-hyderabad-bus-tickets/"
        },
        {
          "name": "Delhi to Jaipur Bus",
          "meta_alt": "Delhi to Jaipur Bus",
          "meta_title": "Delhi to Jaipur Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-jaipur-bus-tickets/"
        },
        {
          "name": "Chennai to Bengaluru Bus",
          "meta_alt": "Chennai to Bengaluru Bus",
          "meta_title": "Chennai to Bengaluru Bus",
          "link": "https://www.goibibo.com/bus/chennai-to-bengaluru-bus-tickets/"
        },
        {
          "name": "Indore to Bhopal Bus",
          "meta_alt": "Indore to Bhopal Bus",
          "meta_title": "Indore to Bhopal Bus",
          "link": "https://www.goibibo.com/bus/indore-to-bhopal-bus-tickets/"
        },
        {
          "name": "Delhi to Shimla Bus",
          "meta_alt": "Delhi to Shimla Bus",
          "meta_title": "Delhi to Shimla Bus",
          "link": "https://www.goibibo.com/bus/delhi-to-shimla-bus-tickets/"
        },
        {
          "name": "Kolkata to Siliguri Bus",
          "meta_alt": "Kolkata to Siliguri Bus",
          "meta_title": "Kolkata to Siliguri Bus",
          "link": "https://www.goibibo.com/bus/kolkata-to-siliguri-bus-tickets/"
        },
        {
          "name": "Bhopal to Indore Bus",
          "meta_alt": "Bhopal to Indore Bus",
          "meta_title": "Bhopal to Indore Bus",
          "link": "https://www.goibibo.com/bus/bhopal-to-indore-bus-tickets/"
        },
        {
          "name": "Pune to Goa Bus",
          "meta_alt": "Pune to Goa Bus",
          "meta_title": "Pune to Goa Bus",
          "link": "https://www.goibibo.com/bus/pune-to-goa-bus-tickets/"
        },
        {
          "name": "Mumbai to Pune Bus",
          "meta_alt": "Mumbai to Pune Bus",
          "meta_title": "Mumbai to Pune Bus",
          "link": "https://www.goibibo.com/bus/mumbai-to-pune-bus-tickets/"
        },
        {
          "name": "Lucknow to Delhi Bus",
          "meta_alt": "Lucknow to Delhi Bus",
          "meta_title": "Lucknow to Delhi Bus",
          "link": "https://www.goibibo.com/bus/lucknow-to-delhi-bus-tickets/"
        },
        {
          "name": "Chandigarh to Manali Bus",
          "meta_alt": "Chandigarh to Manali Bus",
          "meta_title": "Chandigarh to Manali Bus",
          "link": "https://www.goibibo.com/bus/chandigarh-to-manali-bus-tickets/"
        }
      ]
    },
    {
      "title": "Popular Bus Cities",
      "links_data": [
        {
          "name": "Goa Bus Tickets",
          "meta_alt": "Goa Bus Tickets",
          "meta_title": "Goa Bus Tickets",
          "link": "https://www.goibibo.com/bus/goa-buses/"
        },
        {
          "name": "Bangalore Bus Tickets",
          "meta_alt": "Bangalore Bus Tickets",
          "meta_title": "Bangalore Bus Tickets",
          "link": "https://www.goibibo.com/bus/bangalore-buses/"
        },
        {
          "name": "Hyderabad Bus Tickets",
          "meta_alt": "Hyderabad Bus Tickets",
          "meta_title": "Hyderabad Bus Tickets",
          "link": "https://www.goibibo.com/bus/hyderabad-buses/"
        },
        {
          "name": "Chennai Bus Tickets",
          "meta_alt": "Chennai Bus Tickets",
          "meta_title": "Chennai Bus Tickets",
          "link": "https://www.goibibo.com/bus/chennai-buses/"
        },
        {
          "name": "Delhi Bus Tickets",
          "meta_alt": "Delhi Bus Tickets",
          "meta_title": "Delhi Bus Tickets",
          "link": "https://www.goibibo.com/bus/delhi-buses/"
        },
        {
          "name": "Shirdi Bus Tickets",
          "meta_alt": "Shirdi Bus Tickets",
          "meta_title": "Shirdi Bus Tickets",
          "link": "https://www.goibibo.com/bus/shirdi-buses/"
        },
        {
          "name": "Coimbatore Bus Tickets",
          "meta_alt": "Coimbatore Bus Tickets",
          "meta_title": "Coimbatore Bus Tickets",
          "link": "https://www.goibibo.com/bus/coimbatore-buses/"
        },
        {
          "name": "Mumbai Bus Tickets",
          "meta_alt": "Mumbai Bus Tickets",
          "meta_title": "Mumbai Bus Tickets",
          "link": "https://www.goibibo.com/bus/mumbai-buses/"
        },
        {
          "name": "Manali Bus Tickets",
          "meta_alt": "Manali Bus Tickets",
          "meta_title": "Manali Bus Tickets",
          "link": "https://www.goibibo.com/bus/manali-buses/"
        },
        {
          "name": "Kolkata Bus Tickets",
          "meta_alt": "Kolkata Bus Tickets",
          "meta_title": "Kolkata Bus Tickets",
          "link": "https://www.goibibo.com/bus/kolkata-buses/"
        },
        {
          "name": "Pondicherry Bus Tickets",
          "meta_alt": "Pondicherry Bus Tickets",
          "meta_title": "Pondicherry Bus Tickets",
          "link": "https://www.goibibo.com/bus/pondicherry-buses/"
        },
        {
          "name": "Pune Bus Tickets",
          "meta_alt": "Pune Bus Tickets",
          "meta_title": "Pune Bus Tickets",
          "link": "https://www.goibibo.com/bus/pune-buses/"
        },
        {
          "name": "Vijayawada Bus Tickets",
          "meta_alt": "Vijayawada Bus Tickets",
          "meta_title": "Vijayawada Bus Tickets",
          "link": "https://www.goibibo.com/bus/vijayawada-buses/"
        },
        {
          "name": "Mangalore Bus Tickets",
          "meta_alt": "Mangalore Bus Tickets",
          "meta_title": "Mangalore Bus Tickets",
          "link": "https://www.goibibo.com/bus/mangalore-buses/"
        },
        {
          "name": "Kodaikanal Bus Tickets",
          "meta_alt": "Kodaikanal Bus Tickets",
          "meta_title": "Kodaikanal Bus Tickets",
          "link": "https://www.goibibo.com/bus/kodaikanal-buses/"
        },
        {
          "name": "Haridwar Bus Tickets",
          "meta_alt": "Haridwar Bus Tickets",
          "meta_title": "Haridwar Bus Tickets",
          "link": "https://www.goibibo.com/bus/haridwar-buses/"
        },
        {
          "name": "Chandigarh Bus Tickets",
          "meta_alt": "Chandigarh Bus Tickets",
          "meta_title": "Chandigarh Bus Tickets",
          "link": "https://www.goibibo.com/bus/chandigarh-buses/"
        }
      ]
    },
    {
      "title": "Popular RTC Bus Operators",
      "links_data": [
        {
          "name": "APSRTC",
          "meta_alt": "APSRTC",
          "meta_title": "APSRTC",
          "link": "https://www.goibibo.com/bus/apsrtc-andhra-pradesh-state-road-transport-corporation-bus-booking/"
        },
        {
          "name": "TNSTC",
          "meta_alt": "TNSTC",
          "meta_title": "TNSTC",
          "link": "https://www.goibibo.com/bus/tnstc-bus-booking-17101/"
        },
        {
          "name": "UPSRTC",
          "meta_alt": "UPSRTC",
          "meta_title": "UPSRTC",
          "link": "https://www.goibibo.com/bus/upsrtc-uttar-pradesh-state-road-transport-corporation-bus-booking/"
        },
        {
          "name": "MSRTC",
          "meta_alt": "MSRTC",
          "meta_title": "MSRTC",
          "link": "https://www.goibibo.com/bus/msrtc-bus-booking-16884/"
        },
        {
          "name": "TSRTC",
          "meta_alt": "TSRTC",
          "meta_title": "TSRTC",
          "link": "https://www.goibibo.com/bus/tsrtc-bus-booking-18491/"
        },
        {
          "name": "OSRTC",
          "meta_alt": "OSRTC",
          "meta_title": "OSRTC",
          "link": "https://www.goibibo.com/bus/osrtc-odisha-state-road-transport-corporation-bus-booking/"
        },
        {
          "name": "HRTC",
          "meta_alt": "HRTC",
          "meta_title": "HRTC",
          "link": "https://www.goibibo.com/bus/hrtc-1115-bus-booking/"
        },
        {
          "name": "SBSTC",
          "meta_alt": "SBSTC",
          "meta_title": "SBSTC",
          "link": "https://www.goibibo.com/bus/south-bengal-state-transport-corporation-sbstc-bus-booking/"
        },
        {
          "name": "PRTC",
          "meta_alt": "PRTC",
          "meta_title": "PRTC",
          "link": "https://www.goibibo.com/bus/puducherry-road-transport-corporation-prtc-bus-booking/"
        },
        {
          "name": "JKSRTC",
          "meta_alt": "JKSRTC",
          "meta_title": "JKSRTC",
          "link": "https://www.goibibo.com/bus/jksrtc-jammu-kashmir-state-road-transport-corporation-bus-booking/"
        },
        {
          "name": "ASTC",
          "meta_alt": "ASTC",
          "meta_title": "ASTC",
          "link": "https://www.goibibo.com/bus/assam-state-transport-corporation-astc-bus-booking/"
        },
        {
          "name": "GSRTC",
          "meta_alt": "GSRTC",
          "meta_title": "GSRTC",
          "link": "https://www.goibibo.com/bus/gsrtc-gujarat-state-road-transport-corporation-bus-booking/"
        },
        {
          "name": "RSRTC",
          "meta_alt": "RSRTC",
          "meta_title": "RSRTC",
          "link": "https://www.goibibo.com/bus/rsrtc-bus-booking-15499/"
        },
        {
          "name": "KSRTC",
          "meta_alt": "KSRTC",
          "meta_title": "KSRTC",
          "link": "https://www.goibibo.com/bus/ksrtc-kerala-bus-booking-19393/"
        },
        {
          "name": "WBSTC",
          "meta_alt": "WBSTC",
          "meta_title": "WBSTC",
          "link": "https://www.goibibo.com/bus/wbtc-ctc-bus-booking/"
        }
      ]
    },
    {
      "title": "Popular Bus Operators",
      "links_data": [
        {
          "name": "Vrl travels Bus",
          "meta_alt": "Vrl travels Bus",
          "meta_title": "Vrl travels Bus",
          "link": "https://www.goibibo.com/bus/vrl-travels-bus-booking/"
        },
        {
          "name": "Greenline travels and  holidays Bus",
          "meta_alt": "Greenline travels and  holidays Bus",
          "meta_title": "Greenline travels and  holidays Bus",
          "link": "https://www.goibibo.com/bus/greenline-travels-and-holidays-3601-bus-booking/"
        },
        {
          "name": "Neeta travels Bus",
          "meta_alt": "Neeta travels Bus",
          "meta_title": "Neeta travels Bus",
          "link": "https://www.goibibo.com/bus/neeta-travels-16311-bus-booking/"
        },
        {
          "name": "Hans   travels Bus",
          "meta_alt": "Hans   travels Bus",
          "meta_title": "Hans   travels Bus",
          "link": "https://www.goibibo.com/bus/hans-travels-bus-booking/"
        },
        {
          "name": "Shrinath® travel agency pvt. ltd. Bus",
          "meta_alt": "Shrinath® travel agency pvt. ltd. Bus",
          "meta_title": "Shrinath® travel agency pvt. ltd. Bus",
          "link": "https://www.goibibo.com/bus/shrinath-travel-agency-iso-9001-certified-bus-booking/"
        },
        {
          "name": "A p tourism (bhadradri tours & travels) Bus",
          "meta_alt": "A p tourism (bhadradri tours & travels) Bus",
          "meta_title": "A p tourism (bhadradri tours & travels) Bus",
          "link": "https://www.goibibo.com/bus/a-p-tourism-bhadradri-tours-travels-bus-booking/"
        },
        {
          "name": "Kaveri travels Bus",
          "meta_alt": "Kaveri travels Bus",
          "meta_title": "Kaveri travels Bus",
          "link": "https://www.goibibo.com/bus/bharat-travels-via-kamalapur-7737-bus-booking/"
        },
        {
          "name": "Parveen travels Bus",
          "meta_alt": "Parveen travels Bus",
          "meta_title": "Parveen travels Bus",
          "link": "https://www.goibibo.com/bus/parveen-travels-bus-booking-19173/"
        },
        {
          "name": "K.p.n Bus",
          "meta_alt": "K.p.n Bus",
          "meta_title": "K.p.n Bus",
          "link": "https://www.goibibo.com/bus/kpn-bus-booking/"
        },
        {
          "name": "Kallada travels (suresh kallada) Bus",
          "meta_alt": "Kallada travels (suresh kallada) Bus",
          "meta_title": "Kallada travels (suresh kallada) Bus",
          "link": "https://www.goibibo.com/bus/kallada-travels-suresh-kallada-bus-booking/"
        },
        {
          "name": "Shree khurana travels Bus",
          "meta_alt": "Shree khurana travels Bus",
          "meta_title": "Shree khurana travels Bus",
          "link": "https://www.goibibo.com/bus/shree-khurana-travels-bus-booking/"
        },
        {
          "name": "Konduskar travels pvt. ltd. new Bus",
          "meta_alt": "Konduskar travels pvt. ltd. new Bus",
          "meta_title": "Konduskar travels pvt. ltd. new Bus",
          "link": "https://www.goibibo.com/bus/konduskar-travels-pvt-ltd-new-bus-booking/"
        },
        {
          "name": "Srm transports Bus",
          "meta_alt": "Srm transports Bus",
          "meta_title": "Srm transports Bus",
          "link": "https://www.goibibo.com/bus/srm-transports-3384-bus-booking/"
        },
        {
          "name": "Eagle travels Bus",
          "meta_alt": "Eagle travels Bus",
          "meta_title": "Eagle travels Bus",
          "link": "https://www.goibibo.com/bus/eagle-travels-bus-booking/"
        },
        {
          "name": "Vivegam travels Bus",
          "meta_alt": "Vivegam travels Bus",
          "meta_title": "Vivegam travels Bus",
          "link": "https://www.goibibo.com/bus/vivegam-travels-bus-booking-19884/"
        },
        {
          "name": "Universal  travels Bus",
          "meta_alt": "Universal  travels Bus",
          "meta_title": "Universal  travels Bus",
          "link": "https://www.goibibo.com/bus/universal-travels-bus-booking-20131/"
        },
        {
          "name": "Svr tours and travels(apple i bus travels) Bus",
          "meta_alt": "Svr tours and travels(apple i bus travels) Bus",
          "meta_title": "Svr tours and travels(apple i bus travels) Bus",
          "link": "https://www.goibibo.com/bus/svr-tours-and-travelsapple-i-bus-travels-bus-booking/"
        },
        {
          "name": "Saini travels pvt ltd Bus",
          "meta_alt": "Saini travels pvt ltd Bus",
          "meta_title": "Saini travels pvt ltd Bus",
          "link": "https://www.goibibo.com/bus/saini-travels-pvt-ltd-bus-booking/"
        },
        {
          "name": "Mjt travels Bus",
          "meta_alt": "Mjt travels Bus",
          "meta_title": "Mjt travels Bus",
          "link": "https://www.goibibo.com/bus/mjt-travels-bus-booking/"
        },
        {
          "name": "Diwakar travels Bus",
          "meta_alt": "Diwakar travels Bus",
          "meta_title": "Diwakar travels Bus",
          "link": "https://www.goibibo.com/bus/diwakar-travels-2504-bus-booking/"
        },
        {
          "name": "Kesineni travels Bus",
          "meta_alt": "Kesineni travels Bus",
          "meta_title": "Kesineni travels Bus",
          "link": "https://www.goibibo.com/bus/kesineni-travels-bus-booking/"
        },
        {
          "name": "Prasanna  travels Bus",
          "meta_alt": "Prasanna  travels Bus",
          "meta_title": "Prasanna  travels Bus",
          "link": "https://www.goibibo.com/bus/prasanna-travels-11170-bus-booking/"
        }
      ]
    },
    {
      "title": "Our Products",
      "links_data": [
        {
          "name": "Domestic Hotels",
          "link": "https://www.goibibo.com/hotels/"
        },
        {
          "name": "International Hotels",
          "link": "https://www.goibibo.com/hotels-international/"
        },
        {
          "name": "Domestic Flights",
          "link": "https://www.goibibo.com/flights/"
        },
        {
          "name": "International Flights",
          "link": "https://www.goibibo.com/international-flights/"
        },
        {
          "name": "Bus Booking",
          "link": "https://www.goibibo.com/bus/"
        },
        {
          "name": "Cab Booking",
          "link": "https://www.goibibo.com/cars/"
        },
        {
          "name": "Train Ticket Booking",
          "link": "https://www.goibibo.com/trains/"
        },
        {
          "name": "Route Planner",
          "link": "https://www.goibibo.com/routeplanner/"
        },
        {
          "name": "Destination Planner",
          "link": "https://www.goibibo.com/destinations/"
        },
        {
          "name": "Cheap Flights",
          "link": "https://www.goibibo.com/flights/cheap-flights/"
        },
        {
          "name": "Train Running Status",
          "link": "https://www.goibibo.com/trains/check-train-running-status/"
        },
        {
          "name": "PNR Status",
          "link": "https://www.goibibo.com/trains/check-pnr-status/"
        },
        {
          "name": "Airport Cabs",
          "link": "https://www.goibibo.com/cars/airport-cabs/"
        },
        {
          "name": "Hotels in India",
          "link": "https://www.goibibo.com/hotels/india/"
        },
        {
          "name": "Hotels Near Me",
          "link": "https://www.goibibo.com/info/hotels-near-me/"
        },
        {
          "name": "Popular Airlines",
          "link": "https://www.goibibo.com/airlines/"
        },
        {
          "name": "IRCTC Forgot UserID",
          "link": "https://www.goibibo.com/trains/irctc-forgot-userid/"
        },
        {
          "name": "IRCTC Forgot Password",
          "link": "https://www.goibibo.com/trains/irctc-forgot-password/"
        }
      ]
    },
    {
      "title": "Company",
      "links_data": [
        {
          "name": "About US",
          "link": "https://www.goibibo.com/aboutus/"
        },
        {
          "name": "Terms & Conditions",
          "link": "https://www.goibibo.com/info/terms-of-services/"
        },
        {
          "name": "User Agreement",
          "link": "https://www.goibibo.com/info/user-agreement/"
        },
        {
          "name": "Privacy",
          "link": "https://www.goibibo.com/info/privacy/"
        },
        {
          "name": "Contact Us",
          "link": "https://www.goibibo.com/support/"
        },
        {
          "name": "Careers",
          "link": "https://www.goibibo.com/careers/"
        },
        {
          "name": "Corporate Social Responsibility",
          "link": "https://www.goibibo.com/info/corporate-social-responsibility/"
        },
        {
          "name": "Goibibo on Mobile",
          "link": "https://www.goibibo.com/mobile/"
        },
        {
          "name": "Goibibo TV Advertisement",
          "link": "https://www.youtube.com/user/goibibo"
        },
        {
          "name": "Technology@Goibibo",
          "link": "https://tech.goibibo.com/"
        },
        {
          "name": "FAQs",
          "link": "https://www.goibibo.com/support/faq"
        }
      ]
    }
  ]
}

function getBusOffers() {
  return [
    {
      "slug": "payzapp-bus",
      "url": "//www.goibibo.com/offers/payzapp-bus/",
      "sub_heading": "Flat 8% Instant Discount on Bus Bookings",
      "validity_text": "Till 4th Sep'21",
      "img_url": "https://gos3.ibcdn.com/img-1628086318.png",
      "order": 0
    },
    {
      "slug": "hdfc-bus-offer",
      "url": "//www.goibibo.com/offers/hdfc-bus-offer/",
      "sub_heading": "Flat 5% OFF on Bus with HDFC Bank Credit Cards",
      "validity_text": "Limited period offer",
      "img_url": "https://gos3.ibcdn.com/img-1625069014.jpg",
      "order": 4
    },
    {
      "slug": "bus-train-pass",
      "url": "//www.goibibo.com/offers/bus-train-pass/",
      "sub_heading": "Buy Our Exclusive Bus & Train Passes!",
      "validity_text": "Limited Period Offer",
      "img_url": "https://gos3.ibcdn.com/img-1626751565.jpg",
      "order": 6
    },
    {
      "slug": "gosafe-bus",
      "url": "//www.goibibo.com/offers/gosafe-bus/",
      "sub_heading": "Launching goSafe. Stay assured with 3S of SAFETY.",
      "validity_text": "Limited Period Offer",
      "img_url": "https://gos3.ibcdn.com/top-1601646731.jpg",
      "order": 7
    },
    {
      "slug": "new-user-common-bus-extra",
      "url": "//www.goibibo.com/offers/new-user-common-bus-extra/",
      "sub_heading": "Get Flat 5% OFF + a Sign-up Bonus of Rs.50",
      "validity_text": "Limited Period Offer",
      "img_url": "https://gos3.ibcdn.com/img-1609828151.jpg",
      "order": 9
    },
    {
      "slug": "exclusive-bus-offers",
      "url": "//www.goibibo.com/offers/exclusive-bus-offers/",
      "sub_heading": "Get up to ₹100 OFF. Use Promocode: FIRSTBUS",
      "validity_text": "Limited Period Offer",
      "img_url": "https://gos3.ibcdn.com/img-1607921946.jpg",
      "order": 10
    }
  ]
}
